import { render, staticRenderFns } from "./MarkSheetTable.vue?vue&type=template&id=5bcafe12"
import script from "./MarkSheetTable.vue?vue&type=script&lang=js"
export * from "./MarkSheetTable.vue?vue&type=script&lang=js"
import style0 from "./MarkSheetTable.vue?vue&type=style&index=0&id=5bcafe12&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports